import {Aditivo} from "./Aditivo";

export class ColecaoAditivo {

  list: Aditivo[];

}
